import controller from './kform-tab-form.controller';
import template from './kform-tab-form.html';

export default {
	template,
	controller,
	bindings: {
		disabled:   '<?ngDisabled',
		form:       '<',
		kid:        '<',
	},
	require: {
		kform:   '^^?kform',
	},
};
